import React from "react";

interface PackPriceContextState {
  hidePackPricing: boolean;
}

export const PackPriceContext = React.createContext<PackPriceContextState | undefined>(undefined);

export const usePackPriceContext = () => {
  return React.useContext(PackPriceContext)?.hidePackPricing;
};
